import { useCallback, useState } from 'react';
import NoAvatar from '../../assets/images/avatar.svg';
import Modal from 'components/Modal';
import IconButton from 'components/IconButton';
import { SALON_BADGE_LABEL, type SalonBadge } from './salonBadge';

type Props = {
  circle?: boolean;
  size?: `w-${string}`;
  url?: string;
  onClick?: () => void;
  canViewFull?: boolean;
  className?: string;
  containerClassName?: string;
  salonBadge?: SalonBadge;
};

function Avatar({
  circle = false,
  size = `w-full`,
  url,
  onClick,
  canViewFull,
  className = '',
  containerClassName = '',
  salonBadge,
}: Props) {
  const [openFullScreen, setOpenFullScreen] = useState<boolean>(false);

  const handleClick = useCallback(() => {
    if (canViewFull) {
      setOpenFullScreen(true);
    } else onClick && onClick();
  }, [canViewFull, onClick]);

  return (
    <>
      <div
        className={`relative shrink-0 aspect-square ${
          salonBadge ? '[container-type:inline-size]' : ''
        } ${containerClassName} ${size}`}
      >
        <img
          className={`${className} absolute inset-0 h-full w-full object-cover object-top
			      ${circle ? 'rounded-full' : ''} ${
              onClick || canViewFull ? ' cursor-pointer' : ''
            }`}
          src={url || NoAvatar}
          alt=""
          onClick={handleClick}
          onError={(e) => (e.currentTarget.src = NoAvatar)}
        />
        {salonBadge && (
          <div
            className="pointer-events-none flex items-center justify-center py-1 absolute -bottom-1 left-1/2 -translate-x-1/2 rounded-full shadow bg-gradient-to-r from-[#9B6A10] to-[#D6AA44] px-[min(0.75rem,8cqw)] max-w-full text-white"
            title={SALON_BADGE_LABEL}
            aria-label={SALON_BADGE_LABEL}
          >
            <span className="whitespace-nowrap text-start text-[clamp(6px,12cqw,10px)] font-bold leading-none">
              {SALON_BADGE_LABEL}
            </span>
          </div>
        )}
      </div>
      <Modal
        open={openFullScreen && !!url}
        onClose={() => {
          setOpenFullScreen(false);
        }}
      >
        <div
          className="h-svh w-full flex items-center overflow-hidden"
          onClick={() => {
            setOpenFullScreen(false);
          }}
        >
          <IconButton
            icon="close"
            transparent
            className="fixed top-0 left-0 z-50 m-4"
            onClick={(e) => {
              e.stopPropagation();
              setOpenFullScreen(false);
            }}
            iconColor="white"
          />
          <img
            className={`w-full`}
            src={url || NoAvatar}
            alt=""
            onError={(e) => (e.currentTarget.src = NoAvatar)}
          />
        </div>
      </Modal>
    </>
  );
}

export default Avatar;
